<template>
  <div class="home-base">
    <router-view/>
    <div class='common-footer-wrap'>
      <mt-tabbar v-model='home_selected' fixed class="common-footer">
        <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeStoredetail'}" id='home_index'><router-link :to="{ name: 'HomeStoredetail',query:{id:store_id}}" class='item'><img src="../../../assets/image/tab/icon_home_pre.png" class="image" v-if="$route.name=='HomeStoredetail'"><img v-else src="../../../assets/image/tab/icon_home_nor.png" class="image" /><span class='text'>店铺首页</span></router-link></mt-tab-item>
        <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeStoreGoodslist'}" id='home_goodsclass'><router-link :to="{ name: 'HomeStoreGoodslist',query:{id:store_id}}" class='item'><img src="../../../assets/image/tab/icon_allgoodf_selfshop_pre.png" class="image" v-if="$route.name=='HomeStoreGoodslist'"><img v-else src="../../../assets/image/tab/icon_allgoodf_selfshop_nor.png" class="image" /><span class='text'>全部商品</span></router-link></mt-tab-item>
        <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeStoreGoodsclass'}" id='home_search'><router-link :to="{ name: 'HomeStoreGoodsclass',query:{id:store_id}}" class='item'><img src="../../../assets/image/tab/icon_seek_pre.png" class="image" v-if="$route.name=='HomeStoreGoodsclass'"><img v-else src="../../../assets/image/tab/icon_seek_nor.png" class="image" /><span class='text'>店内搜索</span></router-link></mt-tab-item>
        <mt-tab-item class='item-wrap' :class="{'active':$route.name=='HomeCart'}" id='home_cart'><router-link :to="{ name: 'HomeCart'}" class='item'><img src="../../../assets/image/tab/icon_shopping_pre.png" class="image" v-if="$route.name=='HomeCart'"><img v-else src="../../../assets/image/tab/icon_shopping_nor.png" class="image" /><span class='text'>购物车</span></router-link></mt-tab-item>
        <mt-tab-item class='item-wrap' :class="{'active':$route.name=='MemberIndex'}" id='member_index'><router-link :to="{ name: 'MemberIndex'}" class='item'><img src="../../../assets/image/tab/icon_mine_pre.png" class="image" v-if="$route.name=='MemberIndex'"><img v-else src="../../../assets/image/tab/icon_mine_nor.png" class="image" /><span class='text'>我的</span></router-link></mt-tab-item>
      </mt-tabbar>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CommonStoreFooter',
  data () {
    return {
      home_selected: 'home_index'
    }
  },
  props: ['store_id'],
  computed: {

  },
  created: function () {

  }
}
</script>
<style lang="scss" scoped>
  .image{
    width:1rem;
    height:1rem;
    display:block;
    margin-left:auto;
    margin-right:auto;
    margin-top:.2rem;
    margin-bottom:.2rem;
  }
</style>
